import { useEffect } from "react";
import { Client } from "../../../prismic1";
import Prismic from "prismic-javascript";
import Container from "@material-ui/core/Container";
import { RichText } from "prismic-reactjs";
import { useLayout } from "../../../utils/layout-context";
import Projects from "../../../components/Projects";
import { getLanguage, getExtensionLanguage } from "../../../lib/getLanguage";
import Head from "../../../components/Head";
import errorService from '../../../services/error/error-service'

const ProjectCategory = (props) => {

  const {
    currentCategory,
    categories,
    allProjectsBasedOnCategory,
    params,
  } = props;
  const { setHeaderColor } = useLayout();

  useEffect(() => {
    setHeaderColor(true);
  }, []);

  return (
    <>
      <Head data={currentCategory.data} canonical={`/projects/category/${params.uid}`} />
      <Container>
        {currentCategory && allProjectsBasedOnCategory && categories && (
          <Projects
            params={params}
            title={RichText.asText(currentCategory.data.title)}
            subtitle={RichText.asText(currentCategory.data.subtitle)}
            projects={allProjectsBasedOnCategory}
            categories={categories}
            viewAllCategory={true}
          />
        )}
      </Container>
    </>
  );
};

export async function getStaticProps({
  preview = null,
  previewData = {},
  params,
  locale,
}) {
  const client = Client();
  const languageObject = getLanguage(locale);
  const language = await languageObject.prismicLanguage.toLowerCase();
  const categories = await client.query(
    Prismic.Predicates.at("document.type", "project_category"),
    { lang: language }
  );

  const currentCategory = await client.getByUID(
    "project_category",
    params.uid,
    { lang: language }
  );

  if (!currentCategory?.data) {
    return errorService.notFoundResponse
  }

  const allProjectsBasedOnCategory = currentCategory
    ? await client.query(
      [
        Prismic.Predicates.at("document.type", "project"),
        Prismic.Predicates.at(
          "my.project.project_category",
          currentCategory.id
        ),
      ],
      {
        lang: language,
        fetchLinks: ["project_category.icon", "project_category.title"],
      }
    )
    : null;

  return {
    props: {
      currentCategory,
      categories,
      allProjectsBasedOnCategory,
      params,
    },
  };
}

export async function getStaticPaths() {
  const client = Client();
  const projectCategories = await client.query(
    Prismic.Predicates.at("document.type", "project_category"),
    { lang: "*", pageSize: 100 }
  );
  const paths = projectCategories.results.map((node) => {
    const languageObject = getExtensionLanguage(node.lang);
    const language = languageObject.prismicLanguage.toLowerCase();

    return {
      params: {
        uid: node.uid,
      },
      locale: language,
    };
  });
  return {
    paths,
    fallback: 'blocking',
  };
}
export default ProjectCategory;
